/* eslint-disable no-dupe-keys */
<template>
  <div class="company" v-loading="loading">
    <div class="overview">
      <div class="title">我的权益</div>
      <div class="boxs">
        <div class="box">
          <div class="box-title">
            职位刷新点
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="刷新职位，保持新鲜度，提升职位展示和搜索排序！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>
          <div class="box-label" :style="{ marginLeft: '13px' }">
            <span class="box-grey-label">剩</span>
            <span class="box-number-label under" @click="openNumber(1, 5)">
              {{ info.quota.post_refresh_point_surplus }}
            </span>
            <span class="box-grey-label">点</span>
          </div>
          <!-- <div class="box-company">
            <span class="box-grey-label">企业剩余：</span>
            <span class="box-number-label">{{
                  info.product.post_refresh_point
            }}</span>
            <span class="box-grey-label">点</span>
          </div> -->
          <div class="box-button" @click="modal(1)">
            <button>购买更多</button>
          </div>
          <div v-if="numberFlag1" class="number-kf">
            <div class="number-kf-title">
              <span>职位刷新点：共 {{ info.quota.post_refresh_point_surplus != 0 ? info.quota.post_refresh_point_surplus : 0 }}
                点</span>
              <img class="icon" :src="require('$img/company-close.png')" alt="" @click="numberFlag1 = false">
            </div>
            <el-table
                      :data="tableData"
                      class="nunmber-table"
                      style="width: 100%">
              <el-table-column
                               prop="province"
                               label="地区">
              </el-table-column>
              <el-table-column
                               prop="surplus"
                               label="剩余数量">
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="box">
          <div class="box-title">
            职位置顶点
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="置顶职位，多屏「急聘」顶级显示，斩获人才简历！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>
          <div class="box-label" :style="{ marginLeft: '13px' }">
            <span class="box-grey-label">剩</span>
            <span class="box-number-label under" @click="openNumber(2, 3)">
              {{ info.quota.post_top_point_surplus }}
            </span>
            <span class="box-grey-label">点</span>
          </div>
          <!-- <div class="box-company">
            <span class="box-grey-label">企业剩余：</span>
            <span class="box-number-label">{{
                  info.product.post_top_point
            }}</span>
            <span class="box-grey-label">点</span>
          </div> -->
          <div class="box-button" @click="modal(2)">
            <button>购买更多</button>
          </div>
          <div v-if="numberFlag2" class="number-kf">
            <div class="number-kf-title">
              <span>职位置顶点：共 {{ info.quota.post_top_point_surplus != 0 ? info.quota.post_top_point_surplus : 0 }} 点</span>
              <img class="icon" :src="require('$img/company-close.png')" alt="" @click="numberFlag2 = false">
            </div>
            <el-table
                      :data="tableData"
                      class="nunmber-table"
                      style="width: 100%">
              <el-table-column
                               prop="province"
                               label="地区">
              </el-table-column>
              <el-table-column
                               prop="surplus"
                               label="剩余数量">
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="box">
          <div class="box-title">
            职位省心推
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="一键邀投数百名精选人才，地产社群免费覆盖推广，又省时又有效！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>
          <div class="box-label" :style="{ marginLeft: '13px' }">
            <span class="box-grey-label">剩</span>
            <span class="box-number-label under" @click="openNumber(3, 6)">
              {{ info.quota.post_push_point_surplus }}
            </span>
            <span class="box-grey-label">点</span>
          </div>
          <!-- <div class="box-company">
            <span class="box-grey-label">企业剩余：</span>
            <span class="box-number-label">{{
                  info.product.post_push_point
            }}</span>
            <span class="box-grey-label">点</span>
          </div> -->
          <div class="box-button" @click="modal(3)">
            <button>购买更多</button>
          </div>
          <div v-if="numberFlag3" class="number-kf">
            <div class="number-kf-title">
              <span>职位省心推：共 {{ info.quota.post_push_point_surplus != 0 ? info.quota.post_push_point_surplus : 0 }}
                点</span>
              <img class="icon" :src="require('$img/company-close.png')" alt="" @click="numberFlag3 = false">
            </div>
            <el-table
                      :data="tableData"
                      class="nunmber-table"
                      style="width: 100%">
              <el-table-column
                               prop="province"
                               label="地区">
              </el-table-column>
              <el-table-column
                               prop="surplus"
                               label="剩余数量">
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="box">
          <div class="box-title">
            简历下载点
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="人才库下载心仪简历（含电话、微信），无须等待，快速用人！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>
          <div class="box-label" :style="{ marginLeft: '11px' }">
            <span class="box-grey-label">剩</span>
            <span class="box-number-label under" @click="openNumber(4, 4)">
              {{ info.quota.resume_download_num_surplus }}
            </span>
            <span class="box-grey-label">点</span>
          </div>
          <!-- <div class="box-company">
            <span class="box-grey-label">企业剩余：</span>
            <span class="box-number-label">{{
               info.product.resume_download_num
            }}</span>
            <span class="box-grey-label">点</span>
          </div> -->
          <div class="box-button" @click="modal(4)">
            <button>购买更多</button>
          </div>
          <div v-if="numberFlag4" class="number-kf">
            <div class="number-kf-title">
              <span>简历下载点：共 {{ info.quota.resume_download_num_surplus != 0 ? info.quota.resume_download_num_surplus : 0 }}
                点</span>
              <img class="icon" :src="require('$img/company-close.png')" alt="" @click="numberFlag4 = false">
            </div>
            <el-table
                      :data="tableData"
                      class="nunmber-table"
                      style="width: 100%">
              <el-table-column
                               prop="province"
                               label="地区">
              </el-table-column>
              <el-table-column
                               prop="surplus"
                               label="剩余数量">
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="box noBut">
          <div class="box-title">
            职位发布
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="平台内免费发布地产职位">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>

          <div class="box-label">
            <span class="box-number-label">免费</span>
          </div>
          <div class="box-company">
            <span class="box-number-label"> </span>
          </div>
        </div>

        <div class="box noBut">
          <div class="box-title">
            会员等级
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="开通招聘PLUS会员，享更多专属招聘！如需开通可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>

          <div class="box-label">
            <span class="box-number-label">{{
              userInfo.company.member_level === 1 ? "普通会员" : "PLUS会员"
            }}</span>
          </div>
          <div class="box-company">
            <span class="box-number-label"> </span>
          </div>
        </div>

        <div class="box noBut">
          <div class="box-title">
            每日人才邀投
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="向人才发送职位投递邀请，次数每日零点重置！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>

          <div class="box-label">
            <span class="box-grey-label">剩</span>
            <span class="box-number-label">
              {{ info.quota.invite_deliver_day_limit_surplus }}
            </span>
            <span class="box-grey-label">次</span>
          </div>

          <div class="box-company">
            <!-- <span class="box-grey-label">每日零点重置</span> -->
          </div>
        </div>

        <div class="box noBut">
          <div class="box-title">
            企业招聘账号
            <div class="box-tips">
              <el-tooltip
                          placement="top-start"
                          content="多人分工，成员账号管理，招聘权益数量分配！如需获得更多可购买套餐">
                <img :src="$ossUrl + '3.0.0/pc/shuoming.png'" alt="" />
              </el-tooltip>
            </div>
          </div>

          <div class="box-label">
            <span class="box-grey-label">已绑</span>
            <span class="box-number-label">
              {{ info.member.account_count }}
            </span>
            <!-- <span class="box-number-label">{{info.member}}</span> -->
            <span class="box-grey-label">个</span>
          </div>

          <div class="box-company">
            <!-- <span class="box-grey-label">招聘账号上限{{info.member.sub_account_limit}}个</span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="set-meal">
      <div style="width: 1070px">
        <div class="title-wrap">
          <div class="title-view">
            <div class="title">
              套餐选购，更划算
            </div>
            <div class="citysChose">
              <el-select v-model="package_list_value" placeholder="请选择" @change="changeCitys">
                <el-option v-for="item in package_list_options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>

              <div class="tip">点此切换省级套餐<br />享更多优惠</div>
            </div>
          </div>
        </div>
        <div class="text">购买后可开票，发票抬头为当前绑定企业</div>
        <div class="text DFF">如需自由搭配招聘权益的组合，请联系专属服务顾问</div>
        <div class="content">

          <div class="content-row">

            <div class="month" v-if="package_list[0]">
              <div class="space">
                <div class="name">
                  <div class="name-style">
                    <img :src="privilegeIcon" alt="" class="" />
                    {{ package_list[0].package_name }}
                  </div>
                </div>
                <div class="center">
                  <div>
                    <div class="center-left">职位发布</div>
                    <div class="center-right">无限制</div>
                  </div>
                  <div>
                    <div class="center-left">职位刷新</div>
                    <div class="center-right">
                      {{ package_list[0].post_refresh_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位省心推</div>
                    <div class="center-right">
                      {{ package_list[0].post_push_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位置顶</div>
                    <div class="center-right">
                      {{ package_list[0].post_top_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">简历下载</div>
                    <div class="center-right">
                      {{ package_list[0].resume_download_num }}点
                    </div>
                  </div>
                  <div>
                    <span class="center-left">PLUS会员</span>
                    <span class="center-right">赠送</span>
                  </div>
                  <div>
                    <span class="center-left">有效期</span>
                    <span class="center-right">{{ package_list[0].valid_month }}个月</span>
                  </div>
                </div>
                <div class="bottom CCB">
                  <div class="bottom-top" v-if="package_list[0].is_market === 0">
                    <div>
                      <span class="bottom-left">套餐价格</span>
                    </div>
                    <div class="discount">
                      <span class="price">¥{{ package_list[0].price }}</span>
                    </div>
                  </div>
                  <div class="bottom-top" v-else>
                    <div>
                      <span class="bottom-left">原价</span>
                      <span class="original_price">¥{{ package_list[0].original_price }}</span>
                    </div>
                    <div class="discount">
                      <span class="bottom-left">大促价</span>
                      <span class="price">¥{{ package_list[0].price }}</span>
                    </div>
                  </div>
                  <button
                          class="CCB-button"
                          @click="
                            pay(
                              package_list[0].id,
                              package_list[0].price,
                              package_list[0].package_name,
                              1
                            )
                            ">
                    立即购买
                  </button>
                </div>
              </div>
            </div>
            <div class="yearBz" v-if="package_list[1]">
              <div class="space">
                <div class="name">
                  <div class="name-style">
                    <img :src="yearBZ" alt="" class="" />
                    {{ package_list[1].package_name }}
                  </div>
                </div>
                <div class="center">
                  <div>
                    <div class="center-left">职位发布</div>
                    <div class="center-right">无限制</div>
                  </div>
                  <div>
                    <div class="center-left">职位刷新</div>
                    <div class="center-right">
                      {{ package_list[1].post_refresh_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位省心推</div>
                    <div class="center-right">
                      {{ package_list[1].post_push_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位置顶</div>
                    <div class="center-right">
                      {{ package_list[1].post_top_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">简历下载</div>
                    <div class="center-right">
                      {{ package_list[1].resume_download_num }}点
                    </div>
                  </div>
                  <div>
                    <span class="center-left">PLUS会员</span>
                    <span class="center-right">赠送</span>
                  </div>
                  <div>
                    <span class="center-left">有效期</span>
                    <span class="center-right">{{ package_list[1].valid_month }}个月</span>
                  </div>
                </div>
                <div class="bottom F47">
                  <div class="bottom-top" v-if="package_list[1].is_market === 0">
                    <div>
                      <span class="bottom-left">套餐价格</span>
                    </div>
                    <div class="discount">
                      <span class="price">¥{{ package_list[1].price }}</span>
                    </div>
                  </div>
                  <div class="bottom-top" v-else>
                    <div>
                      <span class="bottom-left">原价</span>
                      <span class="original_price">¥{{ package_list[1].original_price }}</span>
                    </div>
                    <div class="discount">
                      <span class="bottom-left">大促价</span>
                      <span class="price">¥{{ package_list[1].price }}</span>
                    </div>
                  </div>
                  <button
                          class="F47-button"
                          @click="
                            pay(
                              package_list[1].id,
                              package_list[1].price,
                              package_list[1].package_name,
                              1
                            )
                            ">
                    立即购买
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div class="content-row">

            <div class="yearCk" v-if="package_list[2]">
              <div class="space">
                <div class="name">
                  <div class="name-style">
                    <img :src="yearCZ" alt="" class="" />
                    {{ package_list[2].package_name }}
                  </div>
                </div>
                <div class="center">
                  <div>
                    <div class="center-left">职位发布</div>
                    <div class="center-right">无限制</div>
                  </div>
                  <div>
                    <div class="center-left">职位刷新</div>
                    <div class="center-right">
                      {{ package_list[2].post_refresh_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位省心推</div>
                    <div class="center-right">
                      {{ package_list[2].post_push_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位置顶</div>
                    <div class="center-right">
                      {{ package_list[2].post_top_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">简历下载</div>
                    <div class="center-right">
                      {{ package_list[2].resume_download_num }}点
                    </div>
                  </div>
                  <div>
                    <span class="center-left">PLUS会员</span>
                    <span class="center-right">赠送</span>
                  </div>
                  <div>
                    <span class="center-left">有效期</span>
                    <span class="center-right">{{ package_list[2].valid_month }}个月</span>
                  </div>
                </div>
                <div class="bottom C55">
                  <div class="bottom-top" v-if="package_list[2].is_market === 0">
                    <div>
                      <span class="bottom-left">套餐价格</span>
                    </div>
                    <div class="discount">
                      <span class="price">¥{{ package_list[2].price }}</span>
                    </div>
                  </div>
                  <div class="bottom-top" v-else>
                    <div>
                      <span class="bottom-left">原价</span>
                      <span class="original_price">¥{{ package_list[2].original_price }}</span>
                    </div>
                    <div class="discount">
                      <span class="bottom-left">大促价</span>
                      <span class="price">¥{{ package_list[2].price }}</span>
                    </div>
                  </div>
                  <button
                          class="C55-button"
                          @click="
                            pay(
                              package_list[2].id,
                              package_list[2].price,
                              package_list[2].package_name,
                              1
                            )
                            ">
                    立即购买
                  </button>
                </div>
              </div>
            </div>

            <!-- S 新增第4个展室位置 -->
            <div class="month" v-if="package_list[3]">
              <div class="space">
                <div class="name">
                  <div class="name-style">
                    <img :src="privilegeIcon" alt="" class="" />
                    {{ package_list[3].package_name }}
                  </div>
                </div>
                <div class="center">
                  <div>
                    <div class="center-left">职位发布</div>
                    <div class="center-right">无限制</div>
                  </div>
                  <div>
                    <div class="center-left">职位刷新</div>
                    <div class="center-right">
                      {{ package_list[3].post_refresh_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位省心推</div>
                    <div class="center-right">
                      {{ package_list[3].post_push_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">职位置顶</div>
                    <div class="center-right">
                      {{ package_list[3].post_top_point }}点
                    </div>
                  </div>
                  <div>
                    <div class="center-left">简历下载</div>
                    <div class="center-right">
                      {{ package_list[3].resume_download_num }}点
                    </div>
                  </div>
                  <div>
                    <span class="center-left">PLUS会员</span>
                    <span class="center-right">赠送</span>
                  </div>
                  <div>
                    <span class="center-left">有效期</span>
                    <span class="center-right">{{ package_list[3].valid_month }}个月</span>
                  </div>
                </div>
                <div class="bottom CCB">
                  <div class="bottom-top" v-if="package_list[3].is_market === 0">
                    <div>
                      <span class="bottom-left">套餐价格</span>
                    </div>
                    <div class="discount">
                      <span class="price">¥{{ package_list[3].price }}</span>
                    </div>
                  </div>
                  <div class="bottom-top" v-else>
                    <div>
                      <span class="bottom-left">原价</span>
                      <span class="original_price">¥{{ package_list[3].original_price }}</span>
                    </div>
                    <div class="discount">
                      <span class="bottom-left">大促价</span>
                      <span class="price">¥{{ package_list[3].price }}</span>
                    </div>
                  </div>
                  <button
                          class="CCB-button"
                          @click="
                            pay(
                              package_list[3].id,
                              package_list[3].price,
                              package_list[3].package_name,
                              1
                            )
                            ">
                    立即购买
                  </button>
                </div>
              </div>
            </div>
            <!-- E 新增第4个展室位置 -->
          </div>

        </div>
        <!-- <div class="title">地产优招套餐</div>
        <div class="top">
          <div class="left">
            <img :src="$ossUrl + '3.0.0/pc/tequan.png'" alt="" />
            <div class="label">
              <div class="label-top">超值招聘套餐，按需选择</div>
              <div class="label-bottom">
                套餐最低仅￥880起，更有多种招聘单品可单独购买，助您招聘提效
              </div>
            </div>
          </div>
          <div class="right">
            <div class="btn" @click="handleRights">购买套餐</div>
          </div>
        </div>
        <div class="icons">
          <div class="icon">
            <img :src="$ossUrl + '3.0.0/pc/ewzw.png'" alt="" />
            <div class="text">无限制免费发布职位</div>
          </div>
          <div class="icon">
            <img :src="$ossUrl + '3.0.0/pc/shuaxin.png'" alt="" />
            <div class="text">职位刷新</div>
          </div>
          <div class="icon">
            <img :src="$ossUrl + '3.0.0/pc/zhiding.png'" alt="" />
            <div class="text">职位置顶</div>
          </div>
          <div class="icon">
            <img :src="zwtg" alt="" />
            <div class="text">职位极速推广</div>
          </div>
          <div class="icon">
            <img :src="$ossUrl + '3.0.0/pc/hxr.png'" alt="" />
            <div class="text">更多候选人</div>
          </div>
        </div> -->
      </div>
      <div class="footer">
        <div class="footer-text">咨询套餐更多权益详情，可联系专属服务顾问</div>
        <div class="footer-style">
          <div class="footer-style-left">
            <span>{{ serviceInfo.service_name }}</span>
            <div class="footer-style-left-tel">
              <div>
                <img :src="rightsTel" alt="" />
                {{ serviceInfo.service_phone }}
              </div>
              <div>
                <img :src="rightsWx" alt="" />
                {{ serviceInfo.service_wechat_no }}
              </div>
            </div>
          </div>
          <button @click="handleKF">让服务顾问联系我</button>
        </div>
      </div>
    </div>
    <!-- <div class="free"   @click="handleFreeDialog">
      <img class="free-img" :src="free" alt="" />
      <div class="btns">
        <div
        class="btn"
      >
        免费领取
      </div>
      </div>
    </div> -->
    <el-dialog
               :visible.sync="freeDialog"
               width="790px"
               title=""
               class="free-dialog">
      <div class="content">
        <img class="banner" :src="banner" alt="" />
        <div class="title">
          凡是入驻地产同行圈的新企业，均可通过官方招聘网站，免费领取价值￥3,000的「招聘PLUS」体验套餐，有效期为1个月，套餐内含：
        </div>
        <div class="items">
          <div class="item">
            <div class="spot"></div>
            <div class="text">【职位发布数】x10个</div>
          </div>
          <div class="item">
            <div class="spot"></div>
            <div class="text">【人才简历下载】x10份</div>
          </div>
          <div class="item">
            <div class="spot"></div>
            <div class="text">【职位刷新频率】x24小时/次</div>
          </div>
          <div class="item">
            <div class="spot"></div>
            <div class="text">【每日人才邀投】x20次/每日</div>
          </div>
          <div class="item">
            <div class="spot"></div>
            <div class="text">【人才库上限】开放15,000+</div>
          </div>
        </div>
        <div class="label">
          <div>*该套餐每家符合条件的企业仅可领取一次；</div>
          <div>
            *若领取前企业已购买其他套餐，则该套餐的生效日期自动顺延至原套餐截止后开始；
          </div>
          <div>
            *该活动解释权归地产同行圈所有，如发现企业存在恶意领取，地产同行圈有权撤销/下架相关权益，并保留法律追究权利；
          </div>
        </div>
        <div class="btns">
          <el-button
                     type="primary"
                     :loading="freeLoading"
                     class="btn"
                     @click="handleReceive()">立即领取</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
               :visible.sync="customerFlag"
               :title="modalTitle"
               width="730px"
               class="modal-kf">
      <div class="modal-kf-content">
        <div class="citysChose">
          <el-select v-model="product_list_value" placeholder="请选择" @change="changeNumberCitys">
            <el-option v-for="item in product_list_options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>


        </div>
        <div class="modal-kf-content-text">{{ modalText }}</div>
        <div class="modal-kf-content-div" v-if="types.length > 0">
          <span>选择购买数量</span>
          <div class="modal-type">
            <div
                 v-for="(item, index) in types"
                 :key="index"
                 class="modal-kf-type"
                 :class="type == index ? 'active' : ''"
                 @click="choseModal(index, item.id, item.price)">
              <div class="C34">{{ item.use_num }}点</div>
              <div class="F47">¥{{ item.price }}</div>
              <div class="F4">
                约¥{{ towNumber(item.price / item.use_num) }}/点
              </div>
              <div class="D88">有效期：{{ item.valid_month }}个月</div>
            </div>
          </div>
        </div>
        <div class="text">购买后可在【招聘权益-购买记录】查看和开票</div>
        <div class="text">发票抬头为当前绑定企业</div>
        <div class="button" @click="pay('', types[type].price, modalTitle, 2)">
          <button :disabled="types.length == 0">去支付</button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="codeDialog" title="" width="380px" class="WXcode">
      <div class="WXcode-content">
        <div class="WXcode-content-top">
          <div class="WXcode-content-top-title">请使用微信扫码支付</div>
          <div id="qrcode" ref="qrcode"></div>
          <div class="name">{{ codeName }}</div>
          <div class="price">¥{{ codePrice }}</div>
          <button @click="renovate">支付完成</button>
        </div>
        <div class="WXcode-content-bottom">
          若支付遇到问题，请联系客服：{{ serviceInfo.service_phone }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import banner from "$img/rights/banner.png";
import free from "$img/rights/free.png";
import zwtg from "$img/rights/zwtg.png";
import privilegeIcon from "@/assets/img/privilege-icon.png";
import yearBZ from "@/assets/img/year-bz.png";
import yearCZ from "@/assets/img/year-cz.png";
import rightsTel from "@/assets/img/rights-tel.png";
import rightsWx from "@/assets/img/rights-wx.png";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";

export default {
  data() {
    return {
      freeDialog: false,
      freeLoading: false,
      customerFlag: false,
      customerFlagLoading: false,
      loading: false,
      banner,
      free,
      zwtg,
      info: {
        member: {},
        product: {},
        employ_activity: {},
        quota: {},
      },
      types: [],
      type: 0,
      modalTitle: "",
      modalText: "",
      package_list: [
        {
          package_name: "基础套餐",
          post_push_point: 50,
          post_refresh_point: 50,
          post_top_point: 50,
          price: 1699,
          resume_download_num: 50,
          valid_month: 12,
        },
        {
          package_name: "基础套餐",
          post_push_point: 50,
          post_refresh_point: 50,
          post_top_point: 50,
          price: 1699,
          resume_download_num: 50,
          valid_month: 12,
        },
        {
          package_name: "基础套餐",
          post_push_point: 50,
          post_refresh_point: 50,
          post_top_point: 50,
          price: 1699,
          resume_download_num: 50,
          valid_month: 12,
        },
      ],
      privilegeIcon,
      yearBZ,
      yearCZ,
      rightsTel,
      rightsWx,
      id: 0,
      price: 0,
      codeDialog: false,
      codeName: "",
      codePrice: 0,

      tableData: [],
      numberFlag1: false,
      numberFlag2: false,
      numberFlag3: false,
      numberFlag4: false,
      pagination: {
        total: 0,
        page: 1,
        count: 20
      },
      productOp: [],
      productValue: null,
      product_list_options: [],
      product_list_value: null,
      package_list_options: [],
      package_list_value: null,
      modalType: 0
    };
  },
  props: [],
  components: {
  },
  computed: {
    ...mapState(["userInfo", "serviceInfo"]),
  },
  created() {
  },
  mounted() {
    this.loadData();
  },
  methods: {
    towNumber(val) {
      return val.toFixed(2);
    },
    modal(type) {
      this.numberFlag1 = false
      this.numberFlag2 = false
      this.numberFlag3 = false
      this.numberFlag4 = false
      this.customerFlag = true;
      this.modalType = type
      let param = {
        product_type: 0,
        province: this.product_list_value
      };
      if (type == 1) {
        param.product_type = 5;
      } else if (type == 2) {
        param.product_type = 3;
      } else if (type == 3) {
        param.product_type = 6;
      } else if (type == 4) {
        param.product_type = 4;
      }
      this.$axios
        .post("/recruitment/goods_employ/product_list", param)
        .then((res) => {
          console.log(res);
          this.modalTitle = res.data.title;
          this.modalText = res.data.summary;
          this.types = res.data.items;
          this.id = res.data.items[0].id;
          this.price = res.data.items[0].price;
          this.type = 0;
        });
    },
    openNumber(type, product_type) {
      this.numberFlag1 = false
      this.numberFlag2 = false
      this.numberFlag3 = false
      this.numberFlag4 = false
      this.product_province_record(product_type)
      if (type == 1) {
        this.numberFlag1 = true
      } else if (type == 2) {
        this.numberFlag2 = true
      } else if (type == 3) {
        this.numberFlag3 = true
      } else if (type == 4) {
        this.numberFlag4 = true
      }
    },
    product_province_record(product_type) {
      this.$axios
        .post("/recruitment/company/product_province_record", {
          product_type: product_type,
          page_flag: 0,
          total_flag: 0,
        })
        .then((res) => {
          console.log(res.data.items);
          this.tableData = res.data.items
          if (this.tableData.length == 0) {
            this.tableData = [{ province: '全国', surplus: 0 }]
          } else {
            this.tableData.map(item => {
              if (item.province == '') {
                item.province = '全国'
              }
            })
          }
        });
    },
    changeCitys(value) {
      console.log(value);
      this.getPackage_list();
    },
    changeNumberCitys(value) {
      console.log(value);
      this.modal(this.modalType)
    },
    choseModal(index, id, price) {
      this.type = index;
      this.id = id;
      this.price = price;
    },
    async loadData() {
      this.loading = true;
      let parme = {
        type: 2
      }
      await this.$axios.post('/recruitment/config/province_city', parme).then((res) => {
        this.productOp = res.data.items.map(item => ({ 'label': item.province, 'value': item.province }));
        this.productOp.unshift({
          value: '',
          label: "全国",
        });
        this.package_list_options = res.data.items.map(item => ({ 'label': item.province, 'value': item.province }));
        this.package_list_options.unshift({
          value: '',
          label: "全国",
        });
        this.package_list_value = '';
        this.product_list_options = res.data.items.map(item => ({ 'label': item.province, 'value': item.province }));
        this.product_list_options.unshift({
          value: '',
          label: "全国",
        });
        this.product_list_value = '';
      })
      if (this.productOp.length > 0) {
        let parme2 = {
          province: this.productValue ? this.productValue : '',
          include_all_flag: this.productValue ? 0 : 1
        }
        await this.$axios.post("/recruitment/company/product", parme2).then((res) => {
          this.info = res.data;
        });
      }
      this.getPackage_list();
      this.loading = false;
    },
    async getPackage_list() {
      let parme = {
        province: this.package_list_value
      }
      await this.$axios.post("/recruitment/goods_employ/package_list", parme).then((res) => {
        this.package_list = res.data.items;
        console.log(this.package_list);
      });
    },
    handleFreeDialog() {
      // this.freeDialog = true;
      this.$router.push("/rights/list");
    },
    handleRights() {
      this.customerFlag = true;
    },
    handleKF() {
      this.customerFlagLoading = true;
      this.$axios
        .post("/recruitment/order_employ/sale_clue")
        .then(() => {
          this.customerFlag = false;
          this.$alert(
            "已收到你的申请，专属服务顾问将尽快与你联系，请你注意接听电话或通过微信好友申请哦~",
            "",
            {
              confirmButtonText: "好的",
              showClose: false,
              callback: () => {
                this.customerFlagLoading = false;
              },
              center: true,
            }
          );
        })
        .catch(() => {
          this.customerFlagLoading = false;
        });
    },
    handleReceive() {
      this.freeLoading = true;
      this.$axios
        .post("/recruitment/employ_activity/new_company_enter")
        .then(() => {
          this.$alert("体验套餐领取成功", "", {
            confirmButtonText: "好的",
            showClose: false,
            callback: () => {
              this.freeDialog = false;
              this.freeLoading = false;
              this.loadData();
            },
            center: true,
          });
        })
        .catch(() => {
          this.freeLoading = false;
        });
    },
    pay(id, price, name, type) {
      let parme = {};
      if (type == 1) {
        //套餐
        parme = {
          type: type,
          id: id,
          price: price,
        };
      } else {
        //产品
        parme = {
          type: type,
          id: this.id,
          price: this.price,
        };
      }
      this.codeName = name;
      this.codePrice = price;
      this.$axios
        .post("/recruitment/order_employ/pay", parme)
        .then((res) => {
          this.customerFlag = false;
          this.codeDialog = true;
          this.loadData();
          this.$nextTick(() => {
            this.$refs.qrcode.innerHTML = "";
            this.qrcode(res.data.pay.code_url);
          });
        })
        .catch((err) => {
          console.log(err);
          // this.freeLoading = false;
        });
      //
    },
    qrcode(code_url) {
      let qrcode = new QRCode("qrcode", {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: code_url, // 设置二维码内容或跳转地址
      });
    },
    renovate() {
      this.loadData();
      this.codeDialog = false;
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
